import React, { Component } from 'react'
import { Marker, Cluster } from 'react-mapbox-gl'
import { connect } from 'react-redux'
import { array, string } from 'prop-types'
import MarkerImage from './MarkerImage'
import ClusterMarkers from './ClusterMarkers'
import { updateInfobox } from '../../../store/Actions/MapActions'
import { maxZoom } from '../../../config'
import { parkingIconsForMap } from '../../../utils/ParkingIcons'
import '../styles/Clusters.css'

class Clusters extends Component {
  clusterMarker = (coordinates, pointCount, getLeaves) => {
    if (coordinates) {
      return (
        <ClusterMarkers
          coordinates={coordinates}
          pointCount={pointCount}
          key={`key${coordinates.join(',')}`}
          category={this.props.category}
          leaves={getLeaves}
        />
      )
    }
  }

  render() {
    return (
      this.props.signs.length > 0 && (
        <Cluster
          ClusterMarkerFactory={this.clusterMarker}
          maxZoom={maxZoom}
          zoomOnClick={false}
          ref={cluster => {
            this.cluster = cluster
          }}
        >
          {this.props.signs.map(
            sign =>
              sign.geometry !== null && (
                <Marker
                  key={sign.properties.id}
                  coordinates={sign.geometry.coordinates}
                  anchor="bottom"
                >
                  <MarkerImage sign={sign} src={parkingIconsForMap(sign)} />
                </Marker>
              )
          )}
        </Cluster>
      )
    )
  }
}

Clusters.propTypes = {
  signs: array.isRequired,
  category: string.isRequired,
}

const mapStateToProps = ({ signsState, spi }) => ({
  signs: signsState.cache.signs,
  category: spi.category[0],
})

const mapDispatchToProps = dispatch => ({
  updateInfobox: value => dispatch(updateInfobox(value)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Clusters)



// WEBPACK FOOTER //
// ./src/components/Map/Markers/Clusters.jsx